import React from 'react';
import ProtegoSymbol from './ProtegoSymbol';

const Hero = ({ companyName }) => {
  return (
    <section className="hero-section">
      <div className="hero-background">
        <img 
          src="/hero-office.png" 
          alt="ПРОТЕГО - Юридичний офіс" 
          className="hero-image"
        />
        <div className="hero-overlay-gradient"></div>
      </div>
      
      <div className="hero-content">
        {/* Brand Symbol */}
        <div className="hero-symbol">
          <ProtegoSymbol size={100} color="#E8D48A" strokeWidth={1.5} />
        </div>
        
        {/* Brand Name */}
        <h1 className="hero-title">{companyName}</h1>
        
        {/* Tagline */}
        <p className="hero-tagline">Адвокатське об'єднання</p>
        
        {/* Decorative line */}
        <div className="hero-line"></div>
      </div>
    </section>
  );
};

export default Hero;
